module.exports = __webpack_public_path__ + "assets/img/hover_sukikamo_planboard.320ce530.svg";